import logo from "../img/logo.png"
const Notification = [
    {
        content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        logo: logo
    },
    {
        content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        logo: logo
    },
    {
        content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        logo: logo
    },
    {
        content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        logo: logo
    },
    {
        content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        logo: logo
    },
    {
        content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        logo: logo
    }
]
export default Notification;